import { application } from '@/controllers/application';

import Copy from '@/controllers/common/copy_controller';
import CouponsIndex from '@/controllers/common/coupons_index_controller';
import CreditCardForm from '@/controllers/common/credit_card_form_controller';
import Heart from '@/controllers/common/heart_controller';
import HorizontalMenu from '@/controllers/common/horizontal_menu_controller';
import IceMenu from '@/controllers/common/ice_menu_controller';
import InstallApp from '@/controllers/common/install_app_controller';
import InvoiceRefund from '@/controllers/common/invoice_refund_controller';
import Map from '@/controllers/common/map_controller';
import MaskCardCvv from '@/controllers/common/mask_card_cvv_controller';
import MaskCardExpirationMonth from '@/controllers/common/mask_card_expiration_month_controller';
import MaskCardExpirationYear from '@/controllers/common/mask_card_expiration_year_controller';
import MaskCardNumber from '@/controllers/common/mask_card_number_controller';
import MaskCpf from '@/controllers/common/mask_cpf_controller';
import MaskDate from '@/controllers/common/mask_date_controller';
import MaskMoney from '@/controllers/common/mask_money_controller';
import MaskNumber from '@/controllers/common/mask_number_controller';
import MaskPercentage from '@/controllers/common/mask_percentage_controller';
import MaskPhone from '@/controllers/common/mask_phone_controller';
import MaskState from '@/controllers/common/mask_state_controller';
import MaskTime from '@/controllers/common/mask_time_controller';
import MaskZipCode from '@/controllers/common/mask_zip_code_controller';
import MegaMenu from '@/controllers/common/mega_menu_controller';
import Menu from '@/controllers/common/menu_controller';
import MenuActions from '@/controllers/common/menu_actions_controller';
import Modal from '@/controllers/common/modal_controller';
import MultiSelect from '@/controllers/common/multi_select_controller';
import Tip from '@/controllers/common/tip_controller';
import Upload from '@/controllers/common/upload_controller';

import EventsAdminCheckin from '@/controllers/events/admin/checkin_controller';
import EventsAdminCheckinScanner from '@/controllers/events/admin/checkin_scanner_controller';
import EventsAdminForm from '@/controllers/events/admin/form_controller';
import EventsTrailsForm from '@/controllers/events/trails/form_controller';
import EventsCheckout from '@/controllers/events/checkout_controller';
import EventsAdminIndex from '@/controllers/events/admin/index_controller';
import EventsIndex from '@/controllers/events/index_controller';
import EventsAdminShow from '@/controllers/events/admin/show_controller';
import EventsEditorsIndex from '@/controllers/events/editors/index_controller';
import EventsOrders from '@/controllers/events/orders_controller';
import EventsRolesIndex from '@/controllers/events/roles/index_controller';
import EventsShow from '@/controllers/events/show_controller';
import EventsTickets from '@/controllers/events/tickets_controller';

application.register('copy', Copy);
application.register('credit-card-form', CreditCardForm);
application.register('heart', Heart);
application.register('horizontal-menu', HorizontalMenu);
application.register('ice-menu', IceMenu);
application.register('install-app', InstallApp);
application.register('invoice-refund', InvoiceRefund);
application.register('map', Map);
application.register('mask-card-cvv', MaskCardCvv);
application.register('mask-card-expiration-month', MaskCardExpirationMonth);
application.register('mask-card-expiration-year', MaskCardExpirationYear);
application.register('mask-card-number', MaskCardNumber);
application.register('mask-cpf', MaskCpf);
application.register('mask-date', MaskDate);
application.register('mask-money', MaskMoney);
application.register('mask-number', MaskNumber);
application.register('mask-percentage', MaskPercentage);
application.register('mask-phone', MaskPhone);
application.register('mask-state', MaskState);
application.register('mask-time', MaskTime);
application.register('mask-zip-code', MaskZipCode);
application.register('mega-menu', MegaMenu);
application.register('menu', Menu);
application.register('menu-actions', MenuActions);
application.register('modal', Modal);
application.register('multi-select', MultiSelect);
application.register('tip', Tip);
application.register('upload', Upload);

application.register('events--admin--checkin', EventsAdminCheckin);
application.register('events--admin--checkin-scanner', EventsAdminCheckinScanner);
application.register('events--admin--form', EventsAdminForm);
application.register('events--trails--form', EventsTrailsForm);
application.register('events--checkout', EventsCheckout);
application.register('events--admin--index', EventsAdminIndex);
application.register('events--admin--show', EventsAdminShow);
application.register('events--coupons--index', CouponsIndex);
application.register('events--editors--index', EventsEditorsIndex);
application.register('events--index', EventsIndex);
application.register('events--orders', EventsOrders);
application.register('events--preview', EventsShow);
application.register('events--roles--index', EventsRolesIndex);
application.register('events--show', EventsShow);
application.register('events--tickets', EventsTickets);

if (document.documentElement.dataset.env === 'development') {
  import('@/controllers/payment_simulator_controller').then(({ default: Controller }) => {
    application.register('payment-simulator', Controller);
  });
}
